import { redirect, openRegisterModal, logout } from "./topNavigation.js";
import ReferalApi from "../../services/api/referralApi.js";
import ShopMobile from "./dropdownMenus/ShopMobile/ShopMobile.vue";
import Search from "./search/search.vue";
import Refer from "./refer/refer.vue";
import { mapGetters } from "vuex";
import Sidebar from "@/views/dashboard/shared/sidebar/sidebar.vue";

const ReferalApiService = new ReferalApi();

export default {
  props: ["isVisible", "categories", "should-display-feed-link"],

  components: {
    Sidebar,
    ShopMobile,
    Search,
    Refer,
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
  data() {
    return {
      link: null,
      copied: false,
      activeDropdown: null,
      activeMenuItem: null,
      isShopExpanded: false,
      isReferralMenuActive: false,
    };
  },

  beforeMount() {
    this.generateLink();
  },

  mounted() {
    this.$eventBus.$on("user-logged-in", this.generateLink);
  },

  beforeDestroy() {
    this.$eventBus.$off("user-logged-in", this.generateLink);
  },

  methods: {
    redirect,
    openRegisterModal,
    shouldDisableEdit,
    handleClick,
    closeSidebar,
    onLogin,
    onLogout,
    logout,
    generateLink,
    copy,
    toggleDropdownMenu,
    emitClose,
  },
};

function shouldDisableEdit(category) {
  // if no user and category is Edits
  return !this.user && category.name === "Edits";
}

function handleClick(data, isContainer) {
  if (this.user) {
    this.$ma.trackEvent({
      action: "Navigation Click",
      properties: {
        "Page Title": data.name,
        "Page Type": data.type,
      },
    });
    const url = isContainer
      ? `/${this.$utils.urlSafeString(data.name)}/${data.id}/products`
      : `/${this.$utils.urlSafeString(data.parentName)}/${this.$utils.urlSafeString(data.name)}/${data.id}/products`;
    this.$router.replace(
      {
        path: url,
      },
      () => this.$eventBus.$emit("init-search")
    );
  } else {
    this.openRegisterModal();
  }

  this.closeSidebar();
}

function closeSidebar() {
  this.isReferralMenuActive = false;
  this.isShopExpanded = false;
  this.activeMenuItem = null;
}

function onLogin() {
  this.$router.push("/sign-in");
  this.$emit("close-sidebar");
}

function onLogout() {
  this.logout();
  this.$emit("close-sidebar");
}

function emitClose() {
  this.$store.dispatch("navigation/toggleSideBar");
}

function copy() {
  this.$refs.refCodeInput.select();
  this.$refs.refCodeInput.setSelectionRange(0, this.$refs.refCodeInput.value.length);
  document.execCommand("copy");
  this.copied = true;
}

function generateLink() {
  if (this.user && this.user.role === "BRAND") {
    ReferalApiService.generateReferLink().then(({ data }) => {
      this.link = data.link;
    });
  }
}

function toggleDropdownMenu(menu) {
  if (this.activeDropdown === menu) {
    this.activeDropdown = null;
  } else {
    this.activeDropdown = menu;
  }
}
